import { grantsFreeMagnets } from '../../utils/offerPricing';

// What the cart summary's coupon row says. A free-ITEM offer has no dollar
// discount; "Discount ... -$0.00" reads as a broken coupon (Alex, #5218
// walk-through) -- name what it grants instead, and skip the redundant
// "Subtotal after Savings" row that would repeat the subtotal. Pure so the
// branching is unit-testable (review on #5264).
export default function couponSummaryLine(coupon, discountValue) {
  if (grantsFreeMagnets(coupon)) {
    return {
      text: 'Included with your package:',
      value: '2 FREE photo magnets',
      useMinus: false,
      showAfterSavings: false,
    };
  }
  return {
    text: `Discount with code: ${coupon.code}`,
    value: discountValue,
    useMinus: typeof discountValue === 'number',
    showAfterSavings: true,
  };
}
